// src/belediye/components/mesajlasma/rehberGruplari.js
// FAZ-82 — REHBER YERLEŞİMİ (TEK KAYNAK).
//
// Kullanıcı (2026-07-30):
//   "En üstte (görme izni varsa) başkanlar olsun, altında başkan yardımcıları.
//    Müdürler, birim personelleri ve saha personelleri BİRİMLERİN ALTINDAN
//    listelensin; birim birim, altındaki kişileri listeleyelim: ilk müdür veya
//    müdürler, sonrasında birim personelleri, sonrasında da saha personelleri.
//    Saha personellerinin adının yanında küçük bir çiple 'saha' yazın. Halk
//    masası rolleri de en altta olsun."
//   (aynı gün, düzeltme) "Başkan Yardımcıları yazısını kaldıralım, burada
//    gruplamaya gerek yok — zaten yukarıda durmaları yeterli. Bir daha başlık
//    eklemeyelim. Ama diğer birimler yapısı güzel, onlar kalsın. Bu yapıyı
//    kişi ekleme kısmına da getirelim."
//
// İKİ TÜKETİCİ: "Yeni sohbet" paneli (NewChatPanel) ve sohbet içi "Kişi ekle"
// (ChatThread → katılımcılar çekmecesi). Yerleşim iki yerde ayrı yazılırsa
// biri değişince öteki sessizce ayrışır — bu yüzden tek fonksiyon.
//
// SÖZLEŞME: kim hangi kademede/birimde olduğunu SUNUCU söyler (`kademe`,
// `unit_id`, `unit_name`, `is_saha` — bkz. ContactsView). Burada YALNIZ yerleşim
// vardır; rütbe/görünürlük kararı istemcide TEKRAR ÜRETİLMEZ.

// Birim başlığı altında listelenen kademeler ve BİRİM İÇİ sıraları.
const BIRIM_ICI = { mudur: 0, personel: 1, saha: 2, diger: 3 };

export const BIRIMSIZ_BASLIK = "Birimi tanımsız";
export const HALK_MASASI_BASLIK = "Halk Masası";

/**
 * Rehber satırlarını görsel bölümlere ayırır.
 *
 * @param {Array} items — her biri {kademe, unitId, unitName, label, …}
 * @returns {Array} [{anahtar, baslik|null, kisiler}] — `baslik === null` ise
 *   başlık satırı ÇİZİLMEZ (makam kademeleri: başkan + yardımcılar).
 */
export default function rehberBolumleri(items) {
  const liste = Array.isArray(items) ? items : [];

  // MAKAM KADEMELERİ — başlıksız, en üstte, kendi aralarında başkan → yardımcı.
  // Kullanıcı kararı: "yukarıda durmaları yeterli", başlık eklenmez.
  const makam = liste
    .filter((s) => s.kademe === "baskan" || s.kademe === "baskan_yardimcisi")
    .sort(
      (a, b) =>
        (a.kademe === "baskan" ? 0 : 1) - (b.kademe === "baskan" ? 0 : 1) ||
        (a.label || "").localeCompare(b.label || "", "tr")
    );

  const halkMasasi = liste.filter((s) => s.kademe === "halk_masasi");

  // BİRİM BAŞLIKLARI — kullanıcı: "diğer birimler yapısı güzel, onlar kalsın".
  const harita = new Map();
  for (const s of liste) {
    if (!(s.kademe in BIRIM_ICI)) continue;
    const anahtar = s.unitId == null ? "" : String(s.unitId);
    if (!harita.has(anahtar)) {
      harita.set(anahtar, { ad: s.unitName || BIRIMSIZ_BASLIK, kisiler: [] });
    }
    harita.get(anahtar).kisiler.push(s);
  }
  const birimBolumleri = [...harita.entries()]
    .sort((a, b) => {
      if (a[0] === "") return 1; // birimi tanımsızlar en sonda
      if (b[0] === "") return -1;
      return a[1].ad.localeCompare(b[1].ad, "tr");
    })
    .map(([anahtar, b]) => ({
      anahtar: `birim-${anahtar || "yok"}`,
      baslik: b.ad,
      kisiler: [...b.kisiler].sort(
        (x, y) =>
          BIRIM_ICI[x.kademe] - BIRIM_ICI[y.kademe] ||
          (x.label || "").localeCompare(y.label || "", "tr")
      ),
    }));

  return [
    { anahtar: "makam", baslik: null, kisiler: makam },
    ...birimBolumleri,
    { anahtar: "halk", baslik: HALK_MASASI_BASLIK, kisiler: halkMasasi },
  ].filter((b) => b.kisiler.length > 0);
}

/** Sunucu alanlarını yerleşimin beklediği şekle çevirir (iki tüketici de aynı). */
export const rehberSatiri = (u) => ({
  type: "user",
  id: u.id,
  label: u.display_name,
  avatar: u.avatar,
  saha: !!u.is_saha,
  kademe: u.kademe || "diger",
  unitId: u.unit_id ?? null,
  unitName: u.unit_name || "",
});
